import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/buttons/Button';
import { FaExclamationTriangle, FaRedo, FaEnvelope } from 'react-icons/fa';
import { authManager, userService } from '../services';
import './NoSubscription.css';
import { createLogger } from '../services/Debug';
function NoSubscription() {
  const log = createLogger('NoSubscription');
  const navigate = useNavigate();
  const [isRetrying, setIsRetrying] = useState(false);
  const [error, setError] = useState(null);
  const [showSupport, setShowSupport] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    setError(null);
    
    try {
      // Try to refresh subscription status
      const user = await userService.getCurrentUser();
      
      if (user && user.subscription_active) {
        // Subscription is now active, redirect to home
        navigate('/home');
      } else {
        // Still no subscription, redirect to subscription selection
        navigate('/auth?step=subscription');
      }
    } catch (err) {
      setError('Unable to verify subscription status. Please try again.');
      log.error('Subscription check failed:', err);
    } finally {
      setIsRetrying(false);
    }
  };

  const handleContactSupport = () => {
    setShowSupport(true);
  };

  const handleLogout = async () => {
    await authManager.logout();
    // Navigation handled by AuthManager; no manual navigate
  };

  return (
    <div className="no-subscription-container">
      <div className="no-subscription-wrapper">
        {/* Logo */}
        <div className="no-sub-header">
          <img src={`${process.env.PUBLIC_URL}/logo_carmin.png`} alt="voxia" className="no-sub-logo" />
          <h1 className="no-sub-title">voxia</h1>
        </div>

        {/* Main Content */}
        <div className="no-sub-content">
          <div className="no-sub-icon">
            <FaExclamationTriangle />
          </div>

          <h2 className="no-sub-heading">
            Subscription Required
          </h2>

          <p className="no-sub-description">
            To access voxia, you need an active subscription. 
            Please complete your subscription to continue.
          </p>

          {error && (
            <div className="no-sub-error">
              {error}
            </div>
          )}

          {/* Action Buttons */}
          <div className="no-sub-actions">
            <Button 
              onClick={handleRetry}
              variant="primary"
              size="large"
              icon={FaRedo}
              disabled={isRetrying}
            >
              {isRetrying ? 'Checking...' : 'Retry'}
            </Button>

            <Button 
              onClick={handleContactSupport}
              variant="secondary"
              size="large"
              icon={FaEnvelope}
            >
              Contact Support
            </Button>
          </div>

          {/* Support Info */}
          {showSupport && (
            <div className="no-sub-support">
              <h3>Need Help?</h3>
              <p>Contact our support team:</p>
              <button
                onClick={() => navigate('/contact')}
                className="support-email"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 0,
                  font: 'inherit'
                }}
              >
                Contactez-nous
              </button>
              <p className="support-hours">
                Monday - Friday: 8:00 - 18:00 CET
              </p>
            </div>
          )}

          {/* Logout Option */}
          <button 
            onClick={handleLogout}
            className="no-sub-logout"
          >
            Sign in with a different account
          </button>
        </div>

        {/* Footer */}
        <div className="no-sub-footer">
          <img src={`${process.env.PUBLIC_URL}/logo_swissmade.png`} alt="Swiss Made" className="swiss-made-logo" />
        </div>
      </div>
    </div>
  );
}

export default NoSubscription;